var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import classNames from 'classnames';
import '../../css/clydeTextInput.css';
var ClydeTextInput = function (props) {
    var className = props.className, disabled = props.disabled, focusDarken = props.focusDarken, hidden = props.hidden, id = props.id, max = props.max, maxLength = props.maxLength, min = props.min, minLength = props.minLength, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onSubmit = props.onSubmit, pattern = props.pattern, placeholder = props.placeholder, readonly = props.readonly, search = props.search, spellcheck = props.spellcheck, step = props.step, subdued = props.subdued, typeNumber = props.typeNumber, value = props.value, dataTestValue = props.dataTestValue;
    var _changeHandler = function (e) {
        if (!disabled && !hidden && !readonly) {
            onChange(e);
        }
    };
    var _blurHandler = function (e) {
        if (!disabled && !hidden && !readonly && onBlur) {
            onBlur(e);
        }
    };
    var _submitHandler = function (e) {
        if (!disabled && !hidden && !readonly && e.key === 'Enter') {
            if (typeof onSubmit === 'function') {
                // If onSubmit exists then it is called instead of submitting form on enter
                e.preventDefault();
                onSubmit(e);
            }
        }
    };
    var _className = classNames('clyde-text-input', className, {
        'clyde-text-input--hidden': hidden,
        'clyde-text-input--disabled': disabled,
        'clyde-text-input--focus-darken': focusDarken,
        'clyde-text-input--subdued': subdued,
        'clyde-text-input--search': search,
    });
    var _props = typeNumber
        ? {
            max: max,
            min: min,
            step: step,
            type: 'number',
        }
        : {
            maxLength: maxLength,
            minLength: minLength,
            pattern: pattern,
            spellCheck: spellcheck,
            type: 'text',
        };
    var contingencyId = "".concat(Date.now() + Math.floor(Math.random() * 1000));
    return (React.createElement("input", __assign({}, _props, { className: _className, disabled: disabled, id: id || contingencyId, "data-test": dataTestValue, name: name, onBlur: _blurHandler, onChange: _changeHandler, onKeyDown: _submitHandler, placeholder: placeholder, readOnly: readonly, value: value })));
};
export default ClydeTextInput;
